import { VersionMigration } from '.';

export default {
  version: '2.4.3',
  migrationFn: async () => {
    // No changes to local storage schema
  },
} as VersionMigration;
